module.exports = __webpack_public_path__ + "img/step34_a_put_the_pocket.4eb5dd33.png";